import { z } from 'zod';

const questionSchema = z.object({
  id: z.string().regex(/^[0-9a-f]{24}$/),
  questionId: z.string().regex(/^[0-9a-f]{24}$/),
  themeId: z.string().regex(/^[0-9a-f]{24}$/).nullable(),
  sectorId: z.string().regex(/^[0-9a-f]{24}$/),
  questionText: z.string().min(1).max(10_000),
  language: z.string().min(1).max(40).nullable(),
  order: z.number().int().positive().nullable(),
  domain: z.string().max(500).nullable(),
  source: z.string().max(2_000).nullable(),
  createdAt: z.string().datetime().nullable(),
}).strict().refine((question) => question.id === question.questionId);

export const sectorQuestionsResponseSchema = z.object({
  error: z.literal(false),
  status: z.literal(200),
  message: z.literal('SECTOR_QUESTIONS_READ'),
  data: z.array(questionSchema).max(300),
  meta: z.object({
    request_id: z.string().uuid(),
    served_at: z.string().datetime(),
    pagination: z.object({
      total: z.number().int().nonnegative(),
      page: z.number().int().positive(),
      limit: z.number().int().min(1).max(300),
      pages: z.number().int().nonnegative(),
      has_more: z.boolean(),
    }).strict(),
  }).strict(),
}).strict();

export type SectorQuestion = z.infer<typeof questionSchema>;
export type SectorQuestionsResponse = z.infer<typeof sectorQuestionsResponseSchema>;
